module.exports = __webpack_public_path__ + "img/img1.166fc466.jpg";